import React, { useRef, useEffect } from 'react';
const HTMLEmail = (props) => {
    const frame = useRef(null);
    const setContentHeight = (doc) => {
        const height = doc?.body?.scrollHeight;
        if (height && frame && frame.current) {
            frame.current.style.height = `${height}px`;
        }
    };
    const updateFrame = (props) => {
        if (frame?.current) {
            const contentWindow = frame.current.contentWindow;
            if (!contentWindow)
                return;
            const doc = contentWindow.document;
            const htmlContent = props?.html || '';
            doc.open();
            doc.write(`
      <html>
        <head>
          <style>
            body { margin: 0; overflow: hidden; }
            img { max-height: 200px; }
          </style>
        </head>
        <body>
          ${htmlContent}
        </body>
      </html>
    `);
            doc.close();
            // Use a timeout to allow rendering before measuring height
            setTimeout(() => setContentHeight(doc), 0);
        }
    };
    useEffect(() => {
        updateFrame();
    }, []);
    useEffect(() => {
        updateFrame(props);
    }, [props.html]);
    return (React.createElement("iframe", { style: {
            width: '100%',
            border: 'none',
            height: 'auto',
        }, src: "about:blank", ref: frame, sandbox: "allow-same-origin allow-scripts", className: "ui-test-5c14306c" }));
};
export default HTMLEmail;
//# sourceMappingURL=HTMLEmail.js.map